import React, { useState, Component, useEffect ,useContext} from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import NotAuth from "./NotAuth.js";
//import { MantineProvider } from '@mantine/core';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication, InteractionStatus } from "@azure/msal-browser";
import { msalConfig, loginRequest, backendRequest, snowBackendRequest } from "./utils/authConfig.js";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { AuthProvider ,AuthContext} from "./authcontext.js";
import { jwtDecode } from "jwt-decode";

import { Login, Home, Footer } from "./components";
import Contactus from "./components/Contactus";
import MdmTicketingHome from "./components/mdm-ticketing/MdmTicketingHome";
// import { RoleContextProvider } from "../context/RoleContext";
// import { FormPageContextProvider } from "../context/formPageContext";
import Tickets from "./components/mdm-ticketing/Tickets";
//import AxiosApi from 'AxiosApi';
import AxiosApi from "./Api.js";
import NavBar from "./components/Navbar";
import FooterComponent from "./components/common/FooterComponent";

//retpack
import RequestFormRetpack from "./components/retPack/Components/requestform";
import ChangePassword from "./components/retPack/Components/changepassword.jsx";
import DashbordRetpack from "./components/retPack/Components/dashbord.jsx";
import ReportDashboard from "./components/retPack/Components/reportDashboard.jsx";
import Resetpassword from "./components/retPack/Components/resetpassword.jsx";
import Userregistration from "./components/retPack/Components/userregistration.jsx";
import Navigation from "./components/retPack/Components/Navigation.jsx";
// import NavBarR from './retPack/Components/navbar.jsx'
// import NavBar from "./Navbar";
//retpack

// OOC
import "./components/ooc/App.css";
import RequestForm from "./components/ooc/oocComponent/reqForm";
import Dashbord from "./components/ooc/oocComponent/dashbord";
import Navbar_OOC from "./components/ooc/oocComponent/navbar";
import Uploader from "./components/ooc/oocComponent/fileUpload";
import Admin from "./components/ooc/oocComponent/createAdmin";
import Archives from "./components/ooc/oocComponent/Archive";
// import Footer from "./ooc/oocComponent/footer";
import UploadPage from "./components/ooc/oocComponent/uploadPage";
// end of OOC

//CQPortalComponents
import HomeComponent from "./components/cq-portal/HomeComponent";
import AddComplaint2 from "./components/cq-portal/AddCommplaint2";
import ComplaintPag2 from "./components/cq-portal/ComplaintPag2"; // needs to be uncomment
import WizardExample from "./components/cq-portal/ComplaintPage3.js";
import Allcomplaints from "./components/cq-portal/All Complaints/Complaints.js";
import Signup from "./components/rbac/Signup"; // ANAS
import NewPassword from "./components/rbac/NewPassword";
import ForgotPassword from "./components/rbac/forgotPassword"; //ANAS
import Header from "./components/rbac/common/Header";
import NotificationsTable from "./components/cq-portal/NotificationsTable";
import { MantineProvider } from "@mantine/core";
import "./assets/styles/App.css";
import { roles, updateRoles as updateGlobalRoles} from "./Constants.js";


const Pages = () => {
  const { accounts, instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { authState, login, logout } = useContext(AuthContext);

  const [email, setEmail] = useState("");
const [isLoggedInViaInput, setisLoggedInViaInput] = useState(false);
  const changeLoggedInViaInput = (bool) => {
    setisLoggedInViaInput(bool);
  };
    const [username, setusername] = useState();
  const [password, setpassword] = useState();

  const isJwtExpired = (token) => {
    try {
      const decoded = jwtDecode(token);
      if (!decoded?.exp) return false;
      return Date.now() >= decoded.exp * 1000;
    } catch (e) {
      return true;
    }
  };

  const logTokenScopeError = (requestName, requestConfig, error) => {
    console.error(`[MSAL] ${requestName} token acquisition failed`, {
      scopes: requestConfig?.scopes || [],
      errorCode: error?.errorCode,
      subError: error?.subError,
      message: error?.errorMessage || error?.message || String(error),
      correlationId: error?.correlationId,
      traceId: error?.traceId,
    });
  };

  const fetchAndApplyRoles = async (email) => {
    try {
      // Ensure email is a string
      const emailStr = typeof email === 'string' ? email : (email?.username || email?.email || email?.toString() || '');
      
      console.log("role Fetching roles for email:", emailStr, "Type:", typeof emailStr);
      
      const res = await AxiosApi.post(
        `${process.env.REACT_APP_API_ROOT_URL_PREFIX}/api/getallrole`,
        { email: emailStr }
      );

      console.log("role backend role response", res.data);

      const roleToken = res.data?.roleToken;

      if (roleToken) {

        const decoded = jwtDecode(roleToken);

        console.log("[ROLE] decoded", decoded);

        //extract roles from nested structure { roles: { cq, retpak, ooc }, email }
        const tokenRoles = decoded.roles || {};
        
        //extract email handle both in string and object formats
        let tokenEmail = decoded.email;
        if (typeof tokenEmail === 'object' && tokenEmail !== null) {
          tokenEmail = tokenEmail.email || tokenEmail.username || tokenEmail.toString() || emailStr;
        }
        if (!tokenEmail || typeof tokenEmail !== 'string') {
          tokenEmail = emailStr;
        }

        console.log("role Extracted email:", tokenEmail, "Type:", typeof tokenEmail);

        //update global constants.js roles
        updateGlobalRoles({
          roleToken,
          roleTokenPayload: {
            cq: tokenRoles.cq || null,
            ooc: tokenRoles.ooc || null,
            retpak: tokenRoles.retpak || null,
            email: tokenEmail,
            iat: decoded.iat,
            exp: decoded.exp
          },
          role: tokenRoles.cq || "",
          ooc_user_role: tokenRoles.ooc || "",
          userRole: tokenRoles.retpak || ""
        });

        //update AuthContext
        login({
          username: tokenEmail,
          email: tokenEmail,
          cq: tokenRoles.cq,
          ooc: tokenRoles.ooc,
          retpack: tokenRoles.retpak,
          isAuthenticate: true
        });

      } else {
        console.warn("role Old role format detected!");

        updateGlobalRoles({
          role: res.data?.cq,
          ooc_user_role: res.data?.ooc,
          userRole: res.data?.retpak
        });

        login({
          username: email,
          email: email,
          cq: res.data?.cq,
          ooc: res.data?.ooc,
          retpack: res.data?.retpak,
          isAuthenticate: true
        });
      }

    } catch (err) {
      console.error("Role fetch failed:", err);
    }
  };

  
  useEffect(() => {
    // Wait for MSAL to finish initializing before attempting to acquire tokens
    if (inProgress !== InteractionStatus.None) {
      console.log("SSO MSAL still initializing.");
      return;
    }

    if (accounts.length === 0) return;

    const graphTokenRequest = {
      ...loginRequest,
      account: accounts[0]
    };
    const backendTokenRequest = {
      ...backendRequest,
      account: accounts[0]
    };

    Promise.allSettled([
      instance.acquireTokenSilent(graphTokenRequest),
      instance.acquireTokenSilent(backendTokenRequest)
    ])
      .then(async ([graphResult, backendResult]) => {
        if (graphResult.status === "rejected") {
          logTokenScopeError("graph", graphTokenRequest, graphResult.reason);
        }

        if (backendResult.status === "rejected") {
          logTokenScopeError("backend", backendTokenRequest, backendResult.reason);
        }

        if (graphResult.status !== "fulfilled" || backendResult.status !== "fulfilled") {
          return;
        }

        const graphResponse = graphResult.value;
        const backendResponse = backendResult.value;
        const emailFromSSO = accounts[0].username;

        setEmail(emailFromSSO);

        localStorage.setItem("email", emailFromSSO);
        localStorage.setItem("idToken", graphResponse.idToken);
        localStorage.setItem("snowtoken", backendResponse.accessToken);
        localStorage.setItem("Authorization", backendResponse.accessToken);

        console.log("SSO Logged in as:", emailFromSSO);

        await fetchAndApplyRoles(emailFromSSO);
      })
      .catch((error) => {
        console.error("Unexpected SSO token acquisition error:", error);
      });

  }, [accounts, inProgress, instance]);

  useEffect(() => {
    const emailStored = localStorage.getItem("email");
    const tokenStored = localStorage.getItem("snowtoken") || localStorage.getItem("Authorization");

    if (!emailStored || !tokenStored) return;

    if (isJwtExpired(tokenStored)) {
      localStorage.removeItem("Authorization");
      localStorage.removeItem("snowtoken");
      return;
    }

    console.log("Stored Logging in from saved credentials");

    setEmail(emailStored);
    fetchAndApplyRoles(emailStored);

  }, []);
  const isAuth = () => {
    const email = localStorage.getItem("email");
    const token = localStorage.getItem("snowtoken") || localStorage.getItem("Authorization");
    return email?.length > 0 && token?.length > 0;
  };
  const isOocAuthorized = (role, allowedRoles = ["1", "2", "3", "4"]) => {
    return allowedRoles.includes(String(role));
  };
  const hasValidRole = (role, allowedRoles = []) => {
    return allowedRoles.includes(String(role));
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/forgotPassword"
          element={
            <React.Fragment>
              <Header />
              <ForgotPassword />
            </React.Fragment>
          }
        />

        <Route
          path="/newPassword"
          element={
            <React.Fragment>
              <Header />
              <NewPassword />
            </React.Fragment>
          }
        />

        <Route
          path="/"
          element={<Home loggedInViaInput={isLoggedInViaInput} />}
        />
        <Route
          path="/register"
          element={
            <React.Fragment>
              <Header />
              <Signup />
            </React.Fragment>
          }
        />

        <Route
          path="/myTickets"
          element={
            roles.username?.length > 0 ? <Tickets /> : <Navigate to="/login" />
          }
        />

        <Route
          path="/contactus"
          element={
            <React.Fragment>
              <NavBar />
              <Contactus />
            </React.Fragment>
          }
        />

        <Route
          path="/mdm"
          element={
            roles.username?.length > 0 ? (
              <MdmTicketingHome />
            ) : (
              // <h1>Work is on Progress. Sorry for inconvenience.</h1>
              <Navigate to="/login" />
            )
          }
        />

        <Route
          path="/login"
          element={
            <Login
              username={username}
              setusername={setusername}
              password={password}
              setpassword={setpassword}
              loggedInViaInputFn={changeLoggedInViaInput}
              loggedInViaInput={isLoggedInViaInput}
              setisLoggedInViaInput={setisLoggedInViaInput}
            />
          }
        />
        {/*CQ Portal routes*/}
        <Route
        path="/cq-portal-home"
        element={
          isAuth() && authState.cq !== 'Employee' ? (
            <HomeComponent />
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      {/* Route: /complaints */}
      <Route
        path="/complaints"
        element={
          isAuth() && authState.cq !== 'Employee' ? (
            <Allcomplaints />
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      {/* Route: /add-complaint */}
      <Route
        path="/add-complaint"
        element={
          isAuth() && (authState.cq != 'Manager' || authState.cq != 'ABI_CQ_SPOC') ? (
            <AddComplaint2 />
          ) : (
            <h1>You are not authorized to view this</h1>
          )
        }
      />

      {/* Route: /complaint/num/:ackno */}
      <Route
        path="/complaint/num/:ackno"
        element={
          isAuth() && !(authState.cq === 'External_Customer' || authState.cq === 'Internal_Customer' || authState.cq === 'Employee') ? (
            <ComplaintPag2 />
          ) : (
            <h1>You are not authorized to view this page</h1>
          )
        }
      />

      {/* Route: /complaint-2/num/:ackno */}
      <Route
        path="/complaint-2/num/:ackno"
        element={
          isAuth() && !(authState.cq === 'ABI_CQ_SPOC' || authState.cq === 'ABI_CQTeam' || authState.cq === 'Employee') ? (
            <WizardExample />
          ) : (
            <h1>You are not authorized to view this page</h1>
          )
        }
      />

      {/* Route: /notificationspage */}
      <Route
        path="/notificationspage"
        element={
          isAuth() ? (
            <NotificationsTable />
          ) : (
            <Navigate to="/login" />
          )
        }
      />
       {/* <Route
  path="/one-order-change-homepage"
  element={
    isAuth() && (authState.ooc == 1 || authState.ooc == 2 || authState.ooc == 3 || authState.ooc == 4) ? (
      <React.Fragment>
        {console.log("inside", authState.ooc)}
        <Navbar_OOC name={authState.username} userRole={authState.ooc} email={authState.email} />
        <RequestForm email={authState.email} />
      </React.Fragment>
    ) : isAuth() ? (
      <NotAuth />
    ) : (
      <Navigate to="/login" />
    )
  }
/>

<Route
  path="/upload2"
  element={
    isAuth() && (authState.ooc == 1 || authState.ooc == 2 || authState.ooc == 3 || authState.ooc == 4) ? (
      <React.Fragment>
        <Navbar_OOC name={authState.username} userRole={authState.ooc} email={authState.email} />
        <UploadPage email={authState.username} />
      </React.Fragment>
    ) : isAuth() ? (
      <NotAuth />
    ) : (
      <Navigate to="/login" />
    )
  }
/>

<Route
  path="/dashboard"
  element={
    isAuth() && (authState.ooc == 1 || authState.ooc == 2 || authState.ooc == 3 || authState.ooc == 4) ? (
      <React.Fragment>
        <Navbar_OOC name={authState.username} userRole={authState.ooc} email={authState.email} />
        <Dashbord email={authState.username} userRole={authState.ooc} />
      </React.Fragment>
    ) : isAuth() ? (
      <NotAuth />
    ) : (
      <Navigate to="/login" />
    )
  }
/>

<Route
  path="/upload"
  element={
    isAuth() && (role.ooc == 1 || role.ooc == 2 || role.ooc == 3 || role.ooc == 4) ? (
      <React.Fragment>
        <Navbar_OOC name={role.username} userRole={role.ooc} email={role.email} />
        <Uploader email={role.username} />
      </React.Fragment>
    ) : isAuth() ? (
      <NotAuth />
    ) : (
      <Navigate to="/login" />
    )
  }
/>

<Route
  path="/userMgmt"
  element={
    isAuth() && (role.ooc == 2 || role.ooc == 3) ? (
      <React.Fragment>
        <Navbar_OOC name={role.username} userRole={role.ooc} email={role.email} />
        {role.ooc == 2 || role.ooc == 3 ? (
          <Admin />
        ) : (
          <RequestForm email={role.username} />
        )}
      </React.Fragment>
    ) : isAuth() ? (
      <NotAuth />
    ) : (
      <Navigate to="/login" />
    )
  }
/>

<Route
  path="/archive"
  element={
    isAuth() && (role.ooc == 2 || role.ooc == 3) ? (
      <React.Fragment>
        <Navbar_OOC name={role.username} userRole={role.ooc} email={role.email} />
        {role.ooc == 2 || role.ooc == 3 ? (
          <Archives />
        ) : (
          <RequestForm email={role.username} />
        )}
      </React.Fragment>
    ) : isAuth() ? (
      <NotAuth />
    ) : (
      <Navigate to="/login" />
    )
  }
/> */}

        


        
       
        {/* retpack */}
        <Route
  path="/retPack"
  element={
    isAuth() ? (
      [1, 2, 3, 4].includes(authState.retpack) ? (
        <React.Fragment>
          <NavBar />
          <Navigation />
          <RequestFormRetpack
            userRole={authState.retpack}
            emailid={authState.username}
            isAuthenticate={true}
            isReady={true}
          />
        </React.Fragment>
      ) : (
        <NotAuth />
      )
    ) : (
      <Navigate to="/login" />
    )
  }
/>

<Route
  path="/retPack/requestform"
  element={
    isAuth() ? (
      [1, 2, 3, 4].includes(authState.retpack) ? (
        <React.Fragment>
          <NavBar />
          <Navigation />
          <RequestFormRetpack
            userRole={authState.retpack}
            emailid={authState.username}
            isAuthenticate={authState.isAuthenticate}
            isReady={true}
          />
        </React.Fragment>
      ) : (
        <NotAuth />
      )
    ) : (
      <Navigate to="/login" />
    )
  }
/>

<Route
  path="/retPack/reports"
  element={
    isAuth() ? (
      [1, 2, 3, 4].includes(authState.retpack) ? (
        <React.Fragment>
          <NavBar />
          <Navigation />
          <ReportDashboard
            userRole={authState.retpack}
            emailid={authState.username}
            isAuthenticate={authState.isAuthenticate}
            isReady={authState.isReady}
          />
        </React.Fragment>
      ) : (
        <NotAuth />
      )
    ) : (
      <Navigate to="/login" />
    )
  }
/>

<Route
  path="/Registration"
  element={
    isAuth() ? (
      [1, 3].includes(authState.retpack) ? (
        <React.Fragment>
          <NavBar />
          <Navigation />
          <Userregistration />
        </React.Fragment>
      ) : (
        <NotAuth />
      )
    ) : (
      <Navigate to="/login" />
    )
  }
/>

<Route
  path="/retPack/Dashboard"
  element={
    isAuth() ? (
      [1, 3].includes(authState.retpack) ? (
        <React.Fragment>
          <NavBar />
          <Navigation />
          <DashbordRetpack />
        </React.Fragment>
      ) : (
        <NotAuth />
      )
    ) : (
      <Navigate to="/login" />
    )
  }
/>


        <Route path="*" element={<h1>Error 404 Page Not Found</h1>} />
      </Routes>
    </BrowserRouter>
  );
};

function App() {
  const msalInstance = new PublicClientApplication(msalConfig);
  return (
    <div className="App">
      <MantineProvider>
        <MsalProvider instance={msalInstance}>
          <AuthProvider>
          {navigator.onLine && <Pages />}
          </AuthProvider>
          {/* {!navigator.onLine && <NoInternet />} */}
        </MsalProvider>
      </MantineProvider>
    </div>
  );
}

export default App;
